import { Stack, Typography, Box } from "@mui/material";
import React from "react";
import { darkGrey } from "../../shared/colours";

const AdditionalServiceInfoCard = (props) =>
{
	return (
		<React.Fragment>
			<Stack
				direction="column"
				sx={{
					width: "20em",
					border: `solid 2px ${darkGrey}`,
					borderRadius: "1.5em",
					paddingTop: "0.5em",
					display: props.isVisible ? "block" : "none",
					overflow: "hidden",

					/* 			visibility: props.isVisible ? 'visible' : 'hidden',
										  height: props.isVisible ? '20em' : 0,
										  transition: "height 0.5s",
										  transitionTimingFunction: "ease-in-out", */
				}}
			>
				<Box
					sx={{
						padding: "1em",
						height: "20em",
					}}
				>
					<Typography
						variant="h10"
						sx={{
							textAlign: "center",
							paddingBottom: "0.1em",
							fontWeight: "bold",
						}}
					>
						{props.title} -
					</Typography>
					<Typography
						variant="h10"
						sx={{
							textAlign: "left",
						}}
					>
						{props.children}
					</Typography>
				</Box>
			</Stack>
		</React.Fragment>
	);
};

export default AdditionalServiceInfoCard;
